export const addToSearch = (payload) => ({
  type: "ADD_TO_SEARCH",
  payload,
})
